import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type FreezeDTO = {
  isFreeze: boolean;
};

type FreezeResponse = ApiError;

export const FreezeStudent = (
  data: FreezeDTO,
  studentId: string,
  courseId: string
): Promise<FreezeResponse> => {
  return axios
    .patch(`/admin/changeFreezeStatus/${studentId}/${courseId}`, data)
    .then((response) => response.data as FreezeResponse);
};
